export type InfoModalCloseReason = 'done' | 'cross' | 'click-outside' | 'tutorial-clicked';
